import { PaymentTerm } from '@domgen/dgx-fe-common';
import { CmsProtectionBenefit } from '../../models/cms/cms-protection-benefit.interface';

export const mockCmsProtectionBenefit: CmsProtectionBenefit = {
  benefit: 'benefit 1',
  paymentTerm: [PaymentTerm.FixedTerm],
};
